__turbopack_context__.v({
  "barFill": "TierProgressBar-module__aPYfXG__barFill",
  "barTrack": "TierProgressBar-module__aPYfXG__barTrack",
  "barsRow": "TierProgressBar-module__aPYfXG__barsRow",
  "container": "TierProgressBar-module__aPYfXG__container",
  "dot": "TierProgressBar-module__aPYfXG__dot",
  "header": "TierProgressBar-module__aPYfXG__header",
  "price": "TierProgressBar-module__aPYfXG__price",
  "spotsLeft": "TierProgressBar-module__aPYfXG__spotsLeft",
  "tierColumn": "TierProgressBar-module__aPYfXG__tierColumn",
  "tierMarker": "TierProgressBar-module__aPYfXG__tierMarker",
  "tierTitle": "TierProgressBar-module__aPYfXG__tierTitle",
});
